import { ValidatingInput, InputComponentProps } from '~/components/validating-input';

export const AddressSecondary = ({ ...props }: InputComponentProps) => {
  const validate = ({ value }) => {
    if (value.trim().length > 128) return 'Address must be 128 characters or less';
    return true;
  };

  return (
    <ValidatingInput
      label="Apartment, suite, etc. (optional)"
      name="addressSecondary"
      maxLength={32}
      optional
      validate={validate}
      {...props}
    />
  );
};
